import { SearchQuery } from "../code/search-query/search-query";
import ManagedGridView from "../controls/ManagedGridView";
import { roadmapColumns, mapNameQuery } from "./ProcessesView.default";
import { getRoadmaps } from "../repository/data.repository";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { createGridRequest } from "../hooks/useGridRequest";

export interface RoadmapsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

// A flat searchable grid of roadmaps. A roadmap is a cohesive aggregate (stages → requirements +
// files), so it's authored in a dedicated "Manage" builder rather than a breadcrumb drill-down.
function RoadmapsView(props: RoadmapsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={roadmapColumns}
      mapQuery={mapNameQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getRoadmaps, { retry: true })}
      pageSize={100}
      schema={{
        groups: [{ controls: [{ type: "textbox", name: "name", label: "Name" }] }],
      }}
      actions={(record) => [
        {
          key: "manage",
          label: "Manage",
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "activate",
          label: "Make Active",
          disabled: record?.isActive || !permissions.can("Processes", "edit"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Processes", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default RoadmapsView;
